export default __webpack_public_path__ + "static/media/it-88.669bad9b.svg";